import { useEffect, useState } from "react";
import Transaction from "../models/Transaction";
import TransactionController from "../controllers/TransactionController";
import { useModal } from "../_providers/ModalProvider";
import { NewTransactionModal } from "../_modals/NewTransactionModal";
import { usePlan } from "../_providers/PlanProvider";
import { useLang } from "../_providers/LangProvider";
import TransactionComponent from "../_components/Transaction";
import Widget from "../_components/Widget";

const ExpenseCategory = ({category, transactions, setError, reloadTransactions}: {category: string, transactions: Transaction[], setError: any, reloadTransactions: () => void}) => {
    const {setModal} = useModal();
    const {translate} = useLang();


    const deleteTransaction = (uid: string) => {
        TransactionController.deleteTransaction(uid).then(() => {
            reloadTransactions();
        }).catch((error) => {
            setError(error.message);
        });
    }

    const trs = transactions.filter((transaction) => transaction.category === category)

    return (
        <Widget title={translate(category)} flex={1} minWidth="300px" canCollapse={true} startCollapse={trs.length > 0}>
            {trs.length == 0 ? <p>No transactions</p> : trs.map((transaction) => (
                    <TransactionComponent item={transaction} onDelete={deleteTransaction}/>
            ))}
            <div>
                <button className="btn" onClick={() => setModal("New transaction", <NewTransactionModal category={category} type="expense" onCreate={() => {reloadTransactions()}}/>)}><p>{translate("create")} {translate(category)}</p> <i className="fa-solid fa-plus" /></button>
            </div>
        </Widget>
    )
}

const ExpensesPage = () => {
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const {translate} = useLang();

    const {selectedPlan} = usePlan();
    
    const reloadTransactions = () => {
        setLoading(true);
        if(!selectedPlan) {
            setError("No plan selected");
            setLoading(false);
            return;
        };
        Promise.all([
            TransactionController.getTransactions(selectedPlan.uid, "expense")
        ]).then(([transactions]) => {
            setTransactions(transactions);
            setLoading(false);
        }).catch((error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    useEffect(() => {
        reloadTransactions();
    }, [selectedPlan]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    return (
        <div style={{paddingBottom: 100}}>
            <h1>{translate("expenses_nav")}</h1>
            <div style={{display: "flex", flexDirection: "column", gap: 5, flexWrap: "wrap"}}>
            {selectedPlan?.expense_categories.sort((a, b) => a.position < b.position ? -1 : 1).map((category) => (
                <ExpenseCategory key={category.uid} category={category.uid} transactions={transactions} setError={setError} reloadTransactions={reloadTransactions} />
            ))}
            </div>
        </div>
    );
}
export default ExpensesPage;